import { atom } from 'jotai'
import { Workspace, Step } from '../types/riskWorkspace.types'

export const riskWorkspaceAtom = atom<Workspace>({
  name: '',
  description: '',
  tags: [],
  access: 'private',
  scenario_sets: [],
  capital_sets: [],
  contextual_layers: [],
  live_groups: [],
  areas: {
    area_type: '',
    areas: [],
  },
})

export const riskWorkspaceStepAtom = atom<Record<Step, boolean>>({
  overview: false,
  hazards_and_scenarios: false,
  capitals: false,
  contextual_layers: false,
  live_layers: false,
  areas: false,
  review_and_save: false,
})

riskWorkspaceAtom.debugLabel = 'Workspace Form'
riskWorkspaceStepAtom.debugLabel = 'Workspace Steps'
